import { Observable } from 'rxjs';

export interface ViCarePlan<T = string> {
  product: string;
  plan: string;
  scope: string;
  features: T[];
  active: boolean;
  isDefault: boolean;
  resourceId: string;
  properties: {
    numberOfApiCalls?: number;
  };
}

export enum DynamicAssistantPlan {
  Basic = 'DynamicAssistantBasic',
  Pro = 'DynamicAssistant',
}

export interface PurchasesApiModel {
  getViCarePlans(installationId: number): Observable<ViCarePlan[]>;
  getUserSubscriptionFeatures(userId: number): Observable<ViCarePlan[]>;
}
